module.exports = __webpack_public_path__ + "img/twitterx.2816c647.svg";